// CourseVocabulary.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./CourseVocabulary.css";
import logo from "./bluelogo.png";
// videos
import BrainDrain from "./CourseContainer/vocabulary/Brain drain.mp4";
import Citizenship from "./CourseContainer/vocabulary/Citizenship .mp4";
import Cultural from "./CourseContainer/vocabulary/Cultural values and issues.mp4";
import Education from "./CourseContainer/vocabulary/Education.mp4";
import Gifts from "./CourseContainer/vocabulary/Gifts of youth.mp4";
import Humor from "./CourseContainer/vocabulary/Humor.mp4";
import InternationalOrganization from "./CourseContainer/vocabulary/International organization .mp4";
import ScienceTechnology from "./CourseContainer/vocabulary/Science and technology.mp4";
import SustainableDevelopment from "./CourseContainer/vocabulary/Sustainable development.mp4";
import WomenPower from "./CourseContainer/vocabulary/Women and power.mp4";
import VocabularyIntro from "./CourseContainer/vocabulary/Vocabulary intro2030.mp4";

// import MixedVocabularyExercises1 from "./CourseContainer/Vocabulary/MixedVocabularyExercises1.mp4";
// import MixedVocabularyExercises2 from "./CourseContainer/Vocabulary/MixedVocabularyExercises2.mp4";

// pdfs

import BrainDrainPdf from "./CourseContainer/pdfs/Vocabulary/Brain drain SUMMARY.pdf";
import CitizenshipPdf from "./CourseContainer/pdfs/Vocabulary/citizenship summary.pdf";
import CulturalPdf from "./CourseContainer/pdfs/Vocabulary/CULTURAL VALUES SUMMARY.pdf";
import EducationPdf from "./CourseContainer/pdfs/Vocabulary/education summary.pdf";
import GiftsPdf from "./CourseContainer/pdfs/Vocabulary/gifts of youth summary.pdf";
import HumorPdf from "./CourseContainer/pdfs/Vocabulary/humouR summary.pdf";
import ScienceTechnologyPdf from "./CourseContainer/pdfs/Vocabulary/SCIENCE and TECHNOLOGY SUMMARY.pdf";

import InternationalOrganizationPdf from "./CourseContainer/pdfs/Vocabulary/International  organizations  summary.pdf";
import SustainableDevelopmentPdf from "./CourseContainer/pdfs/Vocabulary/suistanble developement summary.pdf";
import WomenPowerPdf from "./CourseContainer/pdfs/Vocabulary/WOMEN and POWER SUMMARY.pdf";

import Footer from "./Footer";
import Header from "./Header";

export default function CourseVocabulary() {
  // const tabs = ["Present", "Past", "Future", "Exams"];
  const [activeTab, setActiveTab] = useState("Exams");
  const [query, setQuery] = useState("");

  // which accordion cards are open
  const [openIds, setOpenIds] = useState(() => new Set());

  // only one inline video open at a time
  const [openInlineVideo, setOpenInlineVideo] = useState(null); // { lessonId, itemId, videoSrc, title, subtitle }

  const lessons = useMemo(
    () => [
      {
        id: "introduction-to-Vocabulary",
        title: "Introduction",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "intro-p1",
            label: "Click Play >>",
            duration: "08:26 min",
            videoSrc: VocabularyIntro,
          },
        ],
      },
      {
        id: "Gifts",
        title: "Gifts of youth",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vad-p1",
            label: "Lesson",
            duration: "11:35 min",
            videoSrc: Gifts,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: GiftsPdf,
          },
        ],
      },
      {
        id: "Humor",
        title: "Humor",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vaa-p1",
            label: "Lesson",
            duration: "07:18 min",
            videoSrc: Humor,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: HumorPdf,
          },
        ],
      },
      {
        id: "Education",
        title: "Education",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vac-p1",
            label: "Lesson",
            duration: "07:41 min",
            videoSrc: Education,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: EducationPdf,
          },
        ],
      },
      {
        id: "Sustainable",
        title: "Sustainable development",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vco-p1",
            label: "Lesson",
            duration: "08:02 min",
            videoSrc: SustainableDevelopment,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: SustainableDevelopmentPdf,
          },
        ],
      },
      {
        id: "WomenPower",
        title: "Women and power",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vec-p1",
            label: "Lesson",
            duration: "05:16 min",
            videoSrc: WomenPower,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: WomenPowerPdf,
          },
        ],
      },
      {
        id: "Cultural-values",
        title: "Cultural values and issues",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "var-p1",
            label: "Lesson",
            duration: "06:45 min",
            videoSrc: Cultural,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: CulturalPdf,
          },
        ],
      },
      {
        id: "Citizenship",
        title: "Citizenship",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vmr-p1",
            label: "Lesson",
            duration: "03:41 min",
            videoSrc: Citizenship,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: CitizenshipPdf,
          },
        ],
      },
      {
        id: "International-organization",
        title: "International organization",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vmsu-p1",
            label: "Lesson",
            duration: "04:48 min",
            videoSrc: InternationalOrganization,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: InternationalOrganizationPdf,
          },
        ],
      },
      {
        id: "Science-and-technology",
        title: "Science and technology",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "vres-p1",
            label: "Lesson",
            duration: "06:19 min",
            videoSrc: ScienceTechnology,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: ScienceTechnologyPdf,
          },
        ],
      },
      {
        id: "Brain-drain",
        title: "Brain drain",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "ved-p1",
            label: "Lesson",
            duration: "12:38 min",
            videoSrc: BrainDrain,
          },

          {
            id: "vps-pdf",
            label: "Exercise + Summary",
            kind: "exercise",
            pdfSrc: BrainDrainPdf,
          },
        ],
      },
    
    ],
    []
  );

  const filteredLessons = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return lessons;
    return lessons.filter((l) =>
      `${l.title} ${l.subtitle}`.toLowerCase().includes(q)
    );
  }, [lessons, query]);

  const toggleAccordion = (lessonId) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(lessonId)) next.delete(lessonId);
      else next.add(lessonId);
      return next;
    });
  };

  const toggleInlineVideo = ({
    lessonId,
    itemId,
    videoSrc,
    title,
    subtitle,
  }) => {
    setOpenInlineVideo((curr) => {
      if (curr && curr.lessonId === lessonId && curr.itemId === itemId)
        return null;
      return { lessonId, itemId, videoSrc, title, subtitle };
    });
  };

  // icons defined INSIDE this file (simple)
  const IconPlay = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#4b5563" />
    </svg>
  );

  const IconPlaySmall = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#6b7280" />
    </svg>
  );

  const IconChevronDown = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M7 10l5 5 5-5H7Z" fill="#6b7280" />
    </svg>
  );

  const IconCheck = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.2 16.2 5.5 12.5 4.1 13.9l5.1 5.1L20 8.2 18.6 6.8 9.2 16.2Z"
        fill="#16a34a"
      />
    </svg>
  );
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  window.onscroll = function () {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");

    if (window.scrollY > 50) {
      headerLogo.style.width = "60px";

      header.style.transition = "background 0.3s ease-in-out";
    } else {
      if (window.innerWidth < "668") {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      } else {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      }
    }
  };
  useEffect(() => {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");
    headerLogo.style.width = "60px";
    header.style.background = "white";
  }, []);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div className="VocabularyContainer">
      <header id="All__courses__header">
        <a href="https://toustousacademy.com/">
          <img className="Vocabulary__header__img" src={logo} alt="" />
        </a>
        <ul>
          <a href="/" onClick={scrollToTop}>
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      <div className="tp-page">
        <div className="tp-container">
          <header className="tp-header">
            <h1 className="tp-title">Vocabulary</h1>
            <p className="tp-subtitle">
              Short lessons + practice + correction.
            </p>
          </header>

          <div className="tp-toolbar">
            {/* <div className="tp-tabs">
              {tabs.map((t) => (
                <button
                  key={t}
                  className={`tp-tab ${activeTab === t ? "is-active" : ""}`}
                  onClick={() => setActiveTab(t)}
                  type="button"
                >
                  <span>{t}</span>
                  {t === "Exams" || t === "Future"}
                </button>
              ))}
            </div> */}
          </div>

          <main className="tp-list">
            {filteredLessons.map((lesson) => {
              const isOpen = openIds.has(lesson.id);

              return (
                <article key={lesson.id} className="tp-card">
                  {/* Accordion header */}
                  <button
                    className="tp-accHeader"
                    type="button"
                    onClick={() => toggleAccordion(lesson.id)}
                  >
                    <div className="tp-accLeft">
                      <div className="tp-playCircle" aria-hidden="true">
                        <IconPlay />
                      </div>

                      <div className="tp-cardMain">
                        <div className="tp-cardTitle">{lesson.title}</div>
                        <div className="tp-cardSub">{lesson.subtitle}</div>

                        {lesson.meta && (
                          <div className="tp-pills">
                            {lesson.meta.map((m) => (
                              <span key={m} className="tp-pill">
                                {m}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <span className={`tp-accChev ${isOpen ? "is-open" : ""}`}>
                      <IconChevronDown />
                    </span>
                  </button>

                  {/* Accordion body */}
                  <div className={`tp-accBody ${isOpen ? "is-open" : ""}`}>
                    {lesson.items.map((it) => {
                      const isExercise = it.kind === "exercise";
                      const isThisVideoOpen =
                        openInlineVideo?.lessonId === lesson.id &&
                        openInlineVideo?.itemId === it.id;

                      return (
                        <div key={it.id} className="tp-itemBlock">
                          <div
                            className={`tp-itemRow ${
                              isExercise ? "is-exercise" : ""
                            }`}
                          >
                            <div className="tp-itemLeft">
                              <div
                                className={
                                  isExercise
                                    ? "tp-checkCircle"
                                    : "tp-smallPlayCircle"
                                }
                                aria-hidden="true"
                              >
                                {isExercise ? <IconCheck /> : <IconPlaySmall />}
                              </div>
                              <div className="tp-itemTitle">{it.label}</div>
                            </div>

                            <div className="tp-itemRight">
                              <div className="tp-partDur">
                                {it.duration || ""}
                              </div>

                              {isExercise ? (
                                <a
                                  className="tp-playBtn tp-playBtnLight"
                                  href={it.pdfSrc}
                                  download
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Download PDF
                                  {/* <span className="tp-playBtnChev">›</span> */}
                                </a>
                              ) : (
                                <button
                                  className="tp-playBtn"
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleInlineVideo({
                                      lessonId: lesson.id,
                                      itemId: it.id,
                                      videoSrc: it.videoSrc,
                                      title:
                                      it.label === "Click Play >>"
                                        ? lesson.title
                                        : `${lesson.title} — ${it.label}`,
                                      subtitle: lesson.subtitle,
                                    });
                                  }}
                                >
                                  {isThisVideoOpen ? "Hide" : "Play"}{" "}
                                  <span className="tp-playBtnChev">›</span>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* inline video under the row */}
                          {isThisVideoOpen && (
                            <div className="tp-inlineVideoWrap">
                              <div className="tp-inlineVideoHeader">
                                <div className="tp-inlineVideoTitle">
                                  {openInlineVideo.title}
                                </div>
                                <div className="tp-inlineVideoSub">
                                  {openInlineVideo.subtitle}
                                </div>
                              </div>

                              <video
                                key={openInlineVideo.videoSrc}
                                className="tp-inlineVideo"
                                controlsList="nodownload noplaybackrate"
                                disablePictureInPicture
                                onContextMenu={(e) => e.preventDefault()}
                                controls
                                autoPlay
                                src={openInlineVideo.videoSrc}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </article>
              );
            })}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
